<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ chipText(params.value) || params.value }}</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'cellRendererTransactionsStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (value === 1) return 'success'
        else if (value === 2) return 'warning'
        else if (value === 3) return 'warning'
        else if (value === 4) return 'danger'
        else if (value === 5) return 'dark'
        else if (value === 6) return 'primary'
        else return 'primary'
      }
    },
    chipText () {
      return (value) => {
        if (value === 1) return 'Completed'
        else if (value === 2) return 'Pending'
        else if (value === 3) return 'Reversed'
        else if (value === 4) return 'Error'
        else if (value === 5) return 'Canceled'
        else if (value === 6) return 'Hold'
        else if (value === 7) return 'Insufficient'
        else if (value === 8) return 'Fraud'
        else return value
      }
    }
  }
}
</script>
